var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "15",
        "height": "13",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "#C9C9C9",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2.928 2h11.143C14.584 2 15 1.532 15 .987 15 .442 14.584 0 14.071 0H2.928C2.415 0 2 .442 2 .987 2 1.532 2.415 2 2.928 2zM13.1 5l-7.2.022c-.497 0-.9.421-.9.968C5 6.537 5.403 7 5.9 7l7.2-.02c.497 0 .9-.443.9-.99 0-.547-.403-.99-.9-.99zM14.062 11H.937C.42 11 0 11.448 0 12s.42 1 .937 1h13.125c.518 0 .938-.448.938-1s-.42-1-.938-1z"
      }
    })])]));
  }
};